
export const Language = {
    moneySignBeRight: true, //货币符号是否在后面
    moneySign: "Ks",

    newAPPVersionTip: "New version available. Please refresh to continue playing.",
    NetworkError: "အင်တာနက် အဆင်မပြေပါ။ ပြန်လည်ဝင်ရောက်ကြည့်ပါ။",
    NetworkTimeout: "ချိတ်ဆက်မှု ချွတ်ယွင်းသည်",

    user_kicked_out: "သင့်အကောင့်ကို တခြားနေရာမှာ ဝင်ထားလို့ ထွက်ပေးလိုက်ရတယ်။",

    ConfigError: "ဂိမ်း config ချိတ်ဆက်မရပါ။ ပြန်လည်ဝင်ရောက်ကြည့်ပါ။ အကူအညီလိုလျှင် ဆက်သွယ်ပါ။",

    LoadBundlesError: "ဒေတာများ လှယ်ယူမရပါ။ ပြန်လည်ဝင်ရောက်ကြည့်ပါ။ အကူအညီလိုလျှင် ဆက်သွယ်ပါ။",
    HotUpdateError: "ဒေတာများ လှယ်ယူမရ။ ပြန်ဝင်ကြည့်ပါ။ အကူအညီလိုက ဆက်သွယ်ပါ။",

    exit_game_title: "အသိပေးချက်",
    exit_game_btn_yes: "ဟုတ်ကဲ့",
    exit_game_btn_no: "မဟုတ်ပါဘူး",
    exit_game_confirm: "ဒီဂိမ်းကနေ ထွက်မှာသေချာလား？",
    open_pay_url_confirm: "သင့်အား 777 Vegas မှ စိစစ်အတည်ပြုထားသော ယုံကြည်စိတ်ချရသည့် တတိယပါတီ ဆိုဒ်သို့ ခွင့်ပြုချက်တောင်းခံမည်။ ဆက်လက်လုပ်ဆောင်ရန် 'Yes' ကိုနှိပ်ပါ။",

    MessageID_Error: "ရေတိုထုတ်ပြန်မှုအတွက် စောင့်နေခြင်း",
    MobileNumInvalid: "ကျေးဇူးပြု၍ မှန်ကန်သော ဖုန်းနံပါတ်ကို ထည့်သွင်းပါ。",
    PwdInvalid: "လျှို့ဝှက်နံပါတ် မှားယွင်းနေပါသည်။",
    InvalidSmscode: "OTP မှန်အောင် ထည့်ပါ။",
    OTPHasSent: "OTP ကုဒ်ကို ပို့ပေးပြီးပါပြီ။",
    BindPhoneSuccess: "မိုဘိုင်းဖုန်းနံပါတ် အောင်မြင်စွာ ထည့်ပြီး\n ပါပြီ။ လော့ဘီကို ပြန်သွားပါ၊ ငွေရှာစတင်ပါ！",

    Not_sign: "ဤပွဲသည် VIP ကစားသမားများအတွက်သာဖြစ်သည်။ VIP အဆင့်မြှင့်တင်ရန် ကျေးဇူးပြု၍အရင်ငွေဖြည့်ပါ။",

    VipCardItem_days: "ရက်",
    VipCardItem_reward_now: "%s CASH+%s BONUS ချက်ချင်းရယူပါ!",  //立即获得%d现金+%d奖金
    VipCardItem_reward_everyDay: "နေ့တိုင်း %s CASH+%s BONUS ရယူပါ!",  //每天获得%d现金+%d奖金
    VipCardItem_cash_everyDay: "နေ့တိုင်း %s CASH ရယူပါ!",  //每天获得%d现金
    VipCardItem_bouns_everyDay: "နေ့တိုင်း %s BONUS ရယူပါ!",  //每天获得%d奖金
    VipCardItem_try_later: "ငွေသွင်းခြင်းဆောင်ရွက်ဆဲဖြစ်သည်။ ကျေးဇူးပြု၍ နောက်မှထပ်ကြိုးစားပါ။",  //付款正在进行中，请稍后再试。
    Buy_vip_success: "VIP အခွင့်အရေး ဝယ်ယူပြီးပါပြီ!",
    Get_vip_reward_success: "ဆုလာဘ်များ ရရှိပြီးပါပြီ!",
    PayChannel_toast: "ငွေသွင်းမှု လုပ်ဆောင်ဆဲဖြစ်သည်။ ကျေးဇူးပြု၍ ခဏစောင့်ပေးပါ။",

    Vip_Unlocks: "ဖွင့်ပါ ≥ ",
    ShareModule_click_link: "ဟေ့ကောင်လေး! လင့်ကိုနှိပ်ပြီး အကြီးကြီးအနိုင်ရလိုက်ပါ!",  //你好，我的朋友!点击链接，立即在线赢取大额现金！
    ShareModule_whatapp_tip: "WhatsApp အရင်ထည့်ပါ။",  //请先安装WhatsApp
    ShareModule_Facebook_tip: "ကျေးဇူးပြု၍ Facebook ကို အရင် ထည့်သွင်းပါ။",  //请先安装Facebook
    ShareText_loadingNum: "/%s ယောက် မိတ်ဆွေအရေအတွက်",
    ShareText_loadingNum2: "/%s ဖိတ် %s အသင်း​",
    ShareText_rule_reward: "မိတ်ဆွေတစ်ဦး ငွေသွင်းပြီးရင် သင်က %s ကျပ် ရမယ်",
    ShareText_rule_pay: "မိတ်ဆွေတစ်ဦးရဲ့ငွေသွင်းငွေတိုင်းမှ %s% ရရှိမည်",
    ShareText_rule_level: "≥%s  မိတ်ဆွေများ(Lv.1+Lv.2)ပထမအကြိမ် ငွေသွင်းခြင်း ပြီးမြောက်ခဲ့သည်",

    modify_nickname_success: "အမည်ပြောင်းလဲမှု အောင်မြင်ပါသည်။",
    modify_user_icon_success: "အသုံးပြုသူအိုင်ကွန်ကို မွမ်းမံအောင်မြင်သည်။",

    WithdrawPanel_add_bank: "ကျေးဇူးပြု၍ ဘဏ်အကောင့် ထည့်သွင်းပါ။", //请先添加银行账户.
    withdraw_error_1: "PayTM ID မှားယွင်းနေပါသည်။",
    withdraw_error_2: "အီးမေးလ်ဖော်မက် မှားယွင်းနေပါသည်။",
    withdraw_error_3: "ငွေထုတ်ယူမည့်ပမာဏ ထည့်သွင်းပါ။",
    withdraw_error_4: "အနည်းဆုံး ငွေထုတ်ယူနိုင်သည့် ပမာဏ - %d",
    withdraw_error_5: "အတည်ပြုကုဒ် ပို့ပြီးပြီ။",
    withdraw_error_6: "အတည်ပြုကုဒ် မှားနေတယ်။",
    withdraw_error_7: "ဘဏ်အချက်အလက် မှားနေတယ်။",
    WithdrawPremiumTips: "VIP ကစားသမားများသာ ငွေထုတ်ယူနိုင်ပါသည်။ \nVIP အဖြစ်အဆင့်မြှင့်ရန် ယခုငွေဖြည့်ပါ။",
    WithdrawSuccessDialog: "ထုတ်ယူမှုအောင်မြင်ပါသည်။ ၁၅မိနစ် - ၂၄နာရီအတွင်း ရောက်ရှိမည်။ ပြဿနာရှိပါက ဆက်သွယ်ပါ။",
    dialog_title_tips: "အကြံပြုချက်",
    h5_get_user_scores_fail: "အင်တာနက် မကောင်းပါ။ ပြန်ချိတ်ဆက်ကြည့်ပါ။",
    h5_get_user_scores_confirm: "ချိတ်ဆက်ပါ",
    withdraw_tips_content: "ယနေ့ငွေထုတ်အကန့်အသတ်ကုန်ပြီ။ မနက်ဖြန်ပြန်လာပါ။ \nVIP အဆင့်မြှင့်ပြီး ငွေထုတ်အကန့်အသတ်တိုးပါ။",
    withdraw_tips_confirm: "အတည်ပြုပါ",
    FillEWalletDialogRs_invalid_number: "အကောင့်နံပါတ်မှားယွင်းနေပါသည်။ ၀ နဲ့စလို့မရပါ။",  //帐号无效。帐号不应从0开始。
    FillBankInfoDialog_add_bank_success: "ဘဏ်ကတ်ထည့်ပြီးပြီ။", //添加银行卡成功
    beneficiary_name: "ခံစားခွင့်ရှိသူအမည် ထည့်သွင်းပါ။",  //输入受益人姓名
    BankInfoForms_bank_number: "ဘဏ်အကောင့်နံပါတ် ထည့်သွင်းပါ။",  //输入银行账号
    EWalletInfoForms_ewallet_number: "ကျေးဇူးပြု၍ EWallet အကောင့်နံပါတ်ထည့်သွင်းပါ။",  //输入电子钱包账号
    EWalletInfoForms_valid_bank_number: "ကျေးဇူးပြု၍ မှန်ကန်သော EWallet အကောင့်နံပါတ်ကို ထည့်သွင်းပါ။",  //请输入有效的电子钱包账号
    EWalletInfoForms_same_ewallet_number: "EWallet အကောင့်နံပါတ် ထည့်သွင်းမှု တူညီရပါမည်။",  //电子钱包账号输入必须相同
    EWalletInfoForms_name: "အကောင့်အမည်ကို ရိုက်ထည့်ပါ",  //输入账户名字
    EWalletInfoFormsRs_name: "09xxxxxxxxx",//"အကောင့်နံပါတ်ကို ထည့်သွင်းပါ",  //输入账号
    EWalletInfoFormsRs_ID_number: "09xxxxxxxxx",//"ID Card နံပါတ်ကို ထည့်သွင်းပါ",  //输入身份证号码
    FillBankInfoDialog_IFSC_number: "Enter IFSC Code Number",  //输入IFSC代码
    EWalletInfoFormsRs_valid_name: "ကတ်နံပါတ် ရိုက်ထည့်ပါ",  //请输入有效的账户
    EWalletInfoFormsRs_valid_number: "ကတ်နံပါတ် ထပ်ရိုက်ပါ",  //请输入有效的帐号
    EWalletInfoFormsRs_same_number: "အကောင့်နံပါတ် ထည့်သွင်းမှု တူညီရပါမည်။",  //帐号输入必须相同
    EWalletInfoFormsRs_valid_ID_number: "ကျေးဇူးပြု၍ မှန်ကန်သော မှတ်ပုံတင်နံပါတ် ထည့်သွင်းပါ။", //请输入有效的身份证号码
    FillBankInfoDialog_valid_IFSC_number: "Please enter a valid IFSC Code Number",  //请输入有效的IFSC代码
    FillBankInfo_Error: "IFSC Code is incorrect. Please enter it again.",
    FillBankInfoFifth_Error: "The 5th character of the IFSC Code must be '0'",
    valid_name: "ကျေးဇူးပြု၍ မှန်ကန်သော ခံစားခွင့်ရှိသူအမည် ထည့်သွင်းပါ။",  //请输入有效的受益人姓名
    bank_name: "ကျေးဇူးပြု၍ ဘဏ်အမည်ထည့်သွင်းပါ။",  //输入银行名称
    valid_bank_number: "ကျေးဇူးပြု၍ မှန်ကန်သော ဘဏ်အကောင့်နံပါတ်ကို ထည့်သွင်းပါ။",  //请输入有效的银行帐号
    same_bank_number: "ဘဏ်အကောင့်နံပါတ် ထည့်သွင်းမှု တူညီရပါမည်။",  //银行账号输入必须相同
    valid_bank_name: "ကျေးဇူးပြု၍ မှန်ကန်သော ဘဏ်အမည်ကို ထည့်သွင်းပါ။",  //请输入有效的银行名称
    houseRace_winTxet: "အောင်ပွဲခံပါ! %s က %s ဆု %s မှရရှိ!",  //跑马灯恭喜中奖
    tips: "အကြံပြုချက်",  //提示
    confirm: "အတည်ပြုမည်",  //确认
    notice: "သတိပြုရန်", //通知
    Notice: "သတိပြုရန်", //通知大写
    yes: "ဟုတ်ကဲ့", //是的
    no: "မဟုတ်ပါ", //不是

    transaction_no_more_data: "ငွေလွှဲအချက်အလက် မရှိတော့ပါ",
    transaction_is_first_page: "ပထမစာမျက်နှာရောက်နေပါပြီ",
    AddCashModule_failFun_tip: "အင်တာနက်စစ်ဆေးကာ ပြန်ကြိုးစားပါ။", //请检查网络并重试
    AddCashPayH5: "ကျေးဇူးပြု၍ %s စက္ကန့်အကြာတွင် ခလုတ်ကို ထပ်နှိပ်ပေးပါ။",

    can_find_subgame_info: "ဂိမ်းအချက်အလက်များ ရှာမတွေ့ပါ",
    subgame_is_closed: "ဤဂိမ်းအား မကြာမီ စတင်ဆော့ကစားနိုင်ပါမည်",

    VipEquityView_showLevelUi_Recharge: "ငွေသွင်း %s ဖြင့် VIP%s ဖြစ်လာမည်",
    VipEquityView_showCloseTip_weelpar: "အပတ်စဉ် စတန်းထိုးငွေ ≥ %s",
    VipEquityView_showCloseTip_halfMonthpar: "သီတင်းပတ်ဝက် စတန်းထိုးငွေ ≥ %s",
    VipEquityView_showCloseTip_Monthpar: "လစဉ် စတန်းထိုးငွေ ≥ %s",

    TransactionPanel_activity: "လှုပ်​", // 游戏记录 - 文字 - 活动
    TransactionPanel_money_add: "ငွေထပ်ဖြည့်", // 游戏记录 - 文字 - 添加货币
    TransactionPanel_withdrawal: "ငွေထုတ်ခြင်း​", // 游戏记录 - 文字 - 退出
    TransactionPanel_win: "​​အောင်မြင်ပြီး​ ", // 游戏记录 - 文字 - 赢
    TransactionPanel_loss: "ရှုံးနိမ့်ပြီး​ ", // 游戏记录 - 文字 - 输

    UnPay: "ဆောင်ရွက်ဆဲ​", // 提现中
    FinishPay: "အောင်မြင်မှု", // 成功
    PayFail: "ပျက်ကွက်ပြီး", // 提现失败

    WithdrawFail: "အမှားအယွင်းဖြစ်မှု", // 提现异常失败
    WithdrawFailHandled: "ချို့ယွင်းချက် ကိုင်တွယ်ဖြေရှင်းပြီးပါပြီ", // 异常失败已处理
    WithdrawRejected: "ငြင်းပယ်ခံရ", // 提现已拒绝

    Vip_ERROR: "အင်တာနက် စစ်ဆေးပါ",
    VipRewardGetToday: "ယနေ့ရရှိသောငွေ",
    VipRewardTime: "သက်တမ်းကုန်ဆုံးရန်",
    PayAmount: "ငွေဖြည့်ငွေပမာဏ: ", // "充值金额:",
    Arrived: " ငွေရရှိပြီး", // "已到账!",

    CopySuccess: "အောင်မြင်ပါသည်",
    CopyFail: "ကူးယူးမရပါ。",
    CopyString: "\nဟေ့ကောင်လေး! လင့်ကိုနှိပ်ပြီး အကြီးကြီးအနိုင်ရလိုက်ပါ!", //复制后半段
    MoreClick: "နောက်ထပ်ပွဲများ မကြာမီရောက်ရှိလာပါမည်။",
    EggCapsuleStart: "စတင်ပါ(%s)",
    EggCapsuleStartEnd: "စတင်ခြင်း",
    EggCapsuleErroe: "ဒေတာ အမှား",
    Sharing_link_error: "မျှဝေရန်လင့်ခ် အမှားအယွင်း",//分享链接错误
    WelcomeTip1: "1-ST Deposit Rewards Get %s% Rewards",
    WelcomeTip2: "2-ND Deposit Rewards Get %s% Rewards",
    WelcomeTip3: "3-RD Deposit Rewards Get %s% Rewards",

    BindActivityReward: "ဆုလာဘ်များကြိုဆိုပါသည်။",
    BindActivityBonus: "အပိုဆု ငွေပြောင်း​",
    BindActivityDailyCash: "နေ့တိုင်းဆုငွေ",
    BindActivityVipCard: "VIP ကတ်",
    BindActivityVIPPrivilege: "VIP အခွင့်ထူး",
    BindActivityLuckyWheel: "ကံကောင်းဘီးလုံး",
    BindActivityLuckyGacha: "ကံကောင်းဂါချာ",
    BindActivityRich1: "ဆုလာဘ်မျာ ",
    BindActivityRich2: "အပိုဆုကိုဖွင့်ပြီး အခမဲ့ငွေရယူလိုက်ပါ!",
    BindActivityRich3: "နေ့တိုင်း အခမဲ့ငွေကြေး ချက်ချင်းရယူပါ!",
    BindActivityRich4: "ဆုလာဘ်မျာ ",
    BindActivityRich5: "သင့် VIP ဆုလာဘ်များကို ချက်ချင်းရယူပါ!",
    BindActivityRich6: "<color=#FFFFFF>မိတ်ဆွေဖိတ် = အပိုဆု = </color><color=#FF3838>2K</color><color=#FFFFFF> အခမဲ့!</color>",
    BindActivityRich7: "လှည့်ပြီးအနိုင်ရ!",
    BindActivityRich8: "<color=#8F8F8F>ညွှန်းပါ </color><color=#FFD663>8,888 Ks</color><color=#8F8F8F> ဆုကြေး ရယူပါ!</color>",
    FreeSpinEverydayTip:"Free Spins – Play Slots for FREE!",

    Game_type_name_palyer: 'ဆော့ဖူးဂိမ်း​',
    Game_type_name_hot: 'Hotသောဂိမ်းများ',
    Game_type_name_slots: 'စလော့စက်',
    Game_type_name_tableCard: 'ကဒ်ပြားစားပွဲ',
    Game_type_name_crash: 'အာကေဒီးဆိုင်',
    Game_type_name_arcade: 'အာကေဒီးဆိုင်',
    Game_type_name_fishing: 'ငါးဖမ်းဂိမ်း',
    Game_type_name_casino: 'ကစ္စနို',
    Game_type_name_lottery: 'လော်ထရီ',

    Game_provider_All: 'အားလုံး',
    Game_provider_PG: 'PG',
    Game_provider_JILI: 'JILI',
    Game_provider_SP: 'Spribe',
    Game_provider_CQ9: 'CQ9',
    Game_provider_EV: 'Evolution',
    Game_provider_PP: 'Pragmatic Play',
    Game_provider_JDB: 'JDB',
    Game_provider_TADA: 'TADA',
    Game_provider_RED: 'Red Tiger',
    Game_provider_FaChai: 'FaChai',
    Game_provider_BNG: 'BNG',
    Game_provider_Hacksaw: 'Hacksaw',
    Game_provider_Bgaming: 'Bgaming',
    Game_provider_NextSPIN: 'NextSPIN',
    Game_provider_WONWON: 'WONWON',
    Game_provider_AOG: 'AOG',
    Game_provider_V8: 'V8',
    Game_provider_InOut: 'InOut',
    Game_provider_KoolBet: 'KoolBet',
    Game_provider_Mini: 'Mini',

    SubgameInfoTip1: "လက်ကျန်နည်းနေသည်။ ငွေဖြည့်ပါ။",
    SubgameInfoTip2: "လက်ကျန်ငွေအားလုံးကို စတန်းထိုးရန် အသုံးပြုနိုင်ပါသည်။",
    SubgameInfoTip3: "အခမဲ့ငွေလက်ကျန်ကို ဤဂိမ်းတွင် စတန်းထိုး၍မရပါ။",
    VipConversionTip: "<size=20><color=#f0e6ce>နှုန်းဖြင့် အခမဲ့ငွေသို့ပြောင်းမည်\nစတန်းထိုးတိုင်း Bonus </color>",

    vipCardUp: "Getir",
    vipEquiteConversion1: "<size=14><color=#FFD223>VIP",
    vipEquiteConversion2: "<color=#ffffff> Conversion rate: </color>",

    rolloverAllType: "အားလုံးအမျိုး​",
    rolloverDeposit: "ဖြည့်​",
    rolloverFreeCash: "အခမဲ့ငွေသုံး​",
    RolloverALLSTATUS: "အားလုံးအခြေ​",
    RolloverNOTSTARTED: "မစ",
    RolloverONGOING: "ဆက်ဆဲ​",
    RolloverCOMPLETED: "ပြီး​",
    RolloverCANCELED: "ဖျက်​",

    TurnTableTips: " သာ ဆိုခဲ့သည်",
    TurnTableReward1: " Macbook Pro 16-inch",
    TurnTableReward2: " iPhone 17 Pro ",
    TurnTableReward3: " အခမဲ့လှည့် x2",
    TurnTableReward4: " အခမဲ့လှည့် x1",
    TurnTableReward5: " အခမဲ့ငွေသုံး​",
    TurnTableError: "တစ်ခု လှည့် အခွင့်အလမ်းရဖို့ မည်သည့် ပမာဏကိုမဆို သိုက်သွင်းပါ။.",

    updateLoading: "တင်နေဆဲ... %s%",
    vipCardRedTip: "Get",

    rankDailyTip2: "ယမန်နေ့အဆင့်",
    rankDailyTip: "အရင်နေ့အဆင့်",//前一天的排名
    rankWeeklyTip: "အရင်အပတ်က အဆင့်",//上周排名
    rankCurrentTip: "လက်ရှိအဆင့်",//当前排名
    rankTimeTip: "30 မိနစ်တိုင်း အဆင့်များ အသစ်တင်မည်",
    rankDailyTimeTip: "စာရင်းဇယားအချိန်: %s 00:00 မှ 24:00 အထိ",
    rankWeekTimeTip: "စာရင်းဇယားအချိန်: %s 00:00 မှ %s 24:00 အထိ",

    rankClickDailyTip: `<color=#fff9c0>သင်သည် နေ့စဉ်အဆင့်သတ်မှတ်ချက်တွင်</color><color=#fddb1c> %sth </color><color=#fff9c0>နေရာရရှိပြီး ဆုရရှိပါပြီ</color>`,
    rankClickWeeklyTip: `<color=#fff9c0>သင်သည် အပတ်စဉ်အဆင့်သတ်မှတ်ချက်တွင်</color><color=#fddb1c> %sth </color><color=#fff9c0>ရရှိပြီး ဆုရရှိပါပြီ</color>`,
    vip_tip_withdrawal_desc: "<color=#FF0000>VIP1: 10 နေ့စဉ် ငွေထုတ်အကြိမ်​.</color><color=#EBEBEB>အဆင့်တိုးပြီး ပိုရယူပါ​​</color>",
    vip_tip_withdrawal_desc2 : "<color=#EBEBEB>အဆင့်တိုးပြီး ပိုရယူပါ​​</color>",

    PddBanlance2: "<color=D61010>မင်းလုပ်ခဲ့တယ်။ %s ရရှိခဲ့တယ်။ အခု ငွေကို တောင်းဆိုပါ။!</color>",
    PddBanlance: "<color=#FFD663>%s </color><color=#ECEBEB>ဆိုရင် </color><color=#FFD663>%s </color><color=#ECEBEB>ရယူလိုက်ပါ!</color>",
    PddBanTip: "<color=#ECEBEB>သတင်းကောင်း! </color><b><color=#FFFFFF>%s </color></b><color=#ECEBEB>က </color><b><color=#FFFFFF>%s </color></b><color=#ECEBEB>ဆုငွေကို ရယူလိုက်ပြီ!</color>",
    PddTurnTableError: "မိတ်ဆွေများကို ဖိတ်ခေါ်ပြီး မိုဘိုင်းနံပါတ်ချိတ်ဆက်ကာ Spin အရေအတွက် ပိုမိုရယူပါ။",
    PddTurnTableError2: "ကျေးဇူးပြု၍ ဆုကို တောင်းဆိုပါ",
    PddStatus1: "လုပ်ဆောင်ဆဲ",
    PddStatus2: "ပြီးဆုံးသွားပြီ",
    PddStatus3: "အောင်မြင်ပါပြီ",
    PddFreeCash: "%s Free Cash",
    achieved: "စွမ်းဆောင်ရရှိပြီ",
    PddDownTime: "( %ss )",
    panelShowErroe: "ဒေတာအမှား",
    vipTip: "vipTip",
    Loggings: "မှတ်တမ်းတင်ခြင်း",
    PddGet2: "တောင်းဆိုခဲ့တယ်! အသေးစိတ်အချက်အလက်တွေအတွက် သင့်ပိုက်ဆံအိတ်ကို စစ်ဆေးပါ။",
    MinBet: "လောင်းငွေအနည်းဆုံး: %s Ks",

    payTip: "ငွေပေးချေမှုလင့်ခ်ကိုဖွင့်နေသည်၊ ကျေးဇူးပြု၍စောင့်ပါ။",
    gotoLine: "သင့်အား တတိယပါတီဝဘ်ဆိုက်သို့ ချိတ်ဆက်လိုက်ပါသည်။ ဆက်လုပ်ရန် Yes ကိုနှိပ်ပါ။.",
    GameListAmount: "<color=#898989>လက်ရှိ </color><color=#ea4e51>%s/%s</color><color=#898989> ဂိမ်း​</color>",
    Logging: "ဝင်ရောက်ခြင်း",

    UsernameTip: "4-12 အက္ခရာ/ဂဏန်းသာ",
    Password: "6-12 အက္ခရာ/ဂဏန်းသာ",
    Deleted: "ဖျက်လိုက်ပါပြီ！",
    IsKBZError: "ဒီ KBZ Pay အခြားအကောင့်နာမည်နှင့် ချိတ်ဆက်ထားပါပြီ။ အခြားတစ်ခုဖြည့်စွက်ပါ။",
    ResigsterError:"ကိရိယာ မှတ်ပုံတင်မှုဟာ အထက်ဆုံး ကန့်သတ်မှုကို ရောက်ရှိပါတယ်။",

    LoginNewSuccess:"အကောင့်ကို အောင်မြင်စွာ ထည့်သွင်းပြီးပါပြီ၊ ကျေးဇူးပြု၍ ပြန်လည်ဝင်ရောက်ပါ။",
    UsernameError: "*အကောင့်နာမည်ဖြစ်မသူ！ 4-12 အက္ခရာ/ဂဏန်းသာ",
    UsernameError2: "*အကောင့်နာမည်အားအခြားအသုံးပြုသူအသုံးပြုပြီးပါပြီ！ ပြန်ဖြည့်စွက်ပါ",
    UsernameError3: "*အကောင့်နာမည်မရှိပါ！ ပြန်ဖြည့်စွက် သို့မဟုတ် အကောင့်မှတ်ပုံတင်ပါ",
    UsernameError4: "*မှန်ကန်သော ကိုယ်ရေးအကောင့်အမည်ကို ရိုက်ထည့်ပါ",
    PasswordError: "*မှန်ကန်တဲ့ စကားဝှက်! စာလုံး/နံပါတ် ၆-၁၂ ခုသာပါ။",
    PasswordError2: "*စကားဝှက်မကိုက်ညီပါ။ ကျေးဇူးပြု၍ ပြန်ဝင်ပါ။",
    PasswordError3: "*မှားယွင်းတဲ့ စကားဝှက်! ကျေးဇူးပြု၍ ပြန်ဝင်ပါ။",
    PhoneError: "*ဖုန်းနံပါတ်ဖြစ်မသူ！ ပြန်ဖြည့်စွက်ပါ",
    PhoneError2: "*ဖုန်းနံပါတ်အား အခြားသူမအသုံးပြုပြီးပါပြီ！ ပြန်ဖြည့်စွက်ပါ",
    PhoneError3: "*ဖြည့်စွက်ထားသော ဖုန်းနံပါတ်သည် ဖုန်းနံပါတ်ဟောင်းနှင့်ညီမျှမရှိပါ။ စစ်ဆေးပါ။",

}

